
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/compra-flexible/[brand]",
      function () {
        return require("private-next-pages/es/compra-flexible/[brand]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/compra-flexible/[brand]"])
      });
    }
  